/**
 * ログインユーザー情報
 */
export interface LoginUserInfo{
	userCd:string,
	userName:string,
    branchCd:string,
    branchName:string,
	deptCd:number,
    deptName:string,
    authCd:number,
}
export const initialLoginUserInfo:LoginUserInfo = {
    userCd:"",
    userName:"",
    branchCd:"",
    branchName:"",
    deptCd:0,
    deptName:"",
    authCd:0,
}